import { ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';

class managerYearInlineService {
  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getData(managerId, year) {
    return this.http.get(ENDPOINTS_MANAGER.get.initial(managerId, year)).then(response => {
      return response.data.listRequestsEmployees;
    });
  }
}

export default managerYearInlineService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendar/managerYearInline/managerYearInline.service.js